/**
 * Validation for TextField values: reject values that contain HTML-like markup (no sanitizing).
 * Single-line inputs do not run a separate line-break rule; those controls do not admit newlines in normal use.
 */

/**
 * `<` must start a tag/declaration immediately (no space after `<`), so comparisons like `a < b` or a trailing `<`
 * are allowed. Still matches `<img`, `</p>`, `<!…`, `<?…`.
 */
const HTML_MARKUP_PATTERN = /<(?:\/?[a-zA-Z]|[!?])/i;

export function containsHtmlMarkup(s: string): boolean {
	return HTML_MARKUP_PATTERN.test(s);
}

export function validatePlainText(value: string): string | null {
	if (containsHtmlMarkup(value)) {
		return "This field cannot contain HTML or tags. Remove markup to save.";
	}
	return null;
}

/** Skipped for number/password/nonFormik. Applies to both single-line inputs and textareas (markup only). */
export function shouldValidatePlainTextMarkup(props: {
	component?: "textarea";
	type?: "number" | "password" | "string";
	nonFormik?: boolean;
}): boolean {
	if (props.nonFormik) {
		return false;
	}
	if (props.type === "number" || props.type === "password") {
		return false;
	}
	return true;
}
